import styled from 'styled-components';

interface SectionProps {
  background?: string;
  padding?: string;
  margin?: string;
  borderRadius?: string;
  boxShadow?: string;
  border?: string;
}

export const Section = styled.section<SectionProps>`
  background: ${props => props.background || 'white'};
  padding: ${props => props.padding || '1.5rem'};
  margin: ${props => props.margin || '0'};
  border-radius: ${props => props.borderRadius || '12px'};
  box-shadow: ${props => props.boxShadow || '0 2px 8px rgba(0, 0, 0, 0.1)'};
  border: ${props => props.border || 'none'};
`;